import {AnalysisGraphEdgeData, AnalysisGraphNodeData, DraftAnalysisGraphEdgeData} from './AnalysisGraphTypes';

function getNodeId({step}: Pick<AnalysisGraphNodeData, 'step'>): string {
  return `node-${step.id}`;
}

function getHandleId(stepDataName: string): string {
  return `handle-${stepDataName}`;
}

function getEdgeId({
  parent,
  child,
  parentStepDataName,
  childStepDataName,
}: DraftAnalysisGraphEdgeData): string {
  return `edge-${parent.id}-${child.id}-${parentStepDataName}-${childStepDataName}`;
}

function getEdgeData({
  parent,
  child,
  parentStepDataName,
  childStepDataName,
}: DraftAnalysisGraphEdgeData): AnalysisGraphEdgeData {
  const parentStepData = parent.outputStepDatas.find((stepData) => stepData.name === parentStepDataName)!;
  const childStepData = child.inputStepDatas.find((stepData) => stepData.name === childStepDataName)!;

  const dataFrames = parentStepData.dataFrames.filter((dataFrameInParent) =>
    childStepData.dataFrames.some((dataFrameInChild) => dataFrameInParent.id === dataFrameInChild.id)
  );

  const originatesDataFrameName = dataFrames.some(({name}) =>
    parent.inputStepDatas.every(({dataFrames}) =>
      dataFrames.every(({name: ancestorName}) => ancestorName !== name)
    )
  );

  return {dataFrames, originatesDataFrameName};
}

export default {getEdgeId, getNodeId, getHandleId, getEdgeData};
